import { ALL } from "../../consts/strings";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

export const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    resetFilter: () => initialState,
    resetVolumeOverlayFilters: (state) => {
      Object.keys(state).forEach((field) => {
        if (state[field].volumeOverlayRequired) delete state[field];
      });
    },
    setFilter: (state, action) => {
      const payload = action.payload;
      if (!payload || !payload.field) {
        return;
      }

      if (payload.label === ALL) {
        delete state[payload.field];
      } else {
        state[payload.field] = action.payload;
      }
    },
  },
});

const { actions, reducer } = filtersSlice;
const { setFilter, resetVolumeOverlayFilters, resetFilter } = actions;
export { reducer, setFilter, resetVolumeOverlayFilters, resetFilter };
